import { useState, useRef, useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import AuthPage from '../components/Auth/AuthPage';
import * as api from '../services/api';
import Icons from '../components/Icons';

/* â”€â”€â”€ Gallery placeholder data â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */
const GALLERY = [
  { ar:'3/4',  g:['#0a0520','#1d0850'], vid:false },
  { ar:'1/1',  g:['#050a20','#0a1860'], vid:true  },
  { ar:'9/16', g:['#0c0420','#200860'], vid:false },
  { ar:'16/9', g:['#060820','#0e1850'], vid:true  },
  { ar:'4/5',  g:['#08041a','#180870'], vid:false },
  { ar:'1/1',  g:['#050818','#0a1440'], vid:false },
  { ar:'2/3',  g:['#0a0825','#20107a'], vid:true  },
  { ar:'3/4',  g:['#080a22','#12186a'], vid:false },
  { ar:'16/9', g:['#060a20','#0e1660'], vid:false },
  { ar:'3/2',  g:['#0a0820','#201250'], vid:true  },
  { ar:'1/1',  g:['#060a18','#0e1e40'], vid:false },
  { ar:'4/5',  g:['#08081e','#14146a'], vid:false },
  { ar:'2/3',  g:['#060a1e','#161258'], vid:true  },
  { ar:'1/1',  g:['#080a1e','#141e60'], vid:false },
  { ar:'3/4',  g:['#060a1e','#0e1658'], vid:false },
  { ar:'16/9', g:['#0a0820','#200e50'], vid:true  },
];

const SVG_SHAPES = [
  <circle cx="55%" cy="45%" r="28%" fill="rgba(109,40,217,0.10)"/>,
  <rect x="20%" y="20%" width="60%" height="60%" rx="6" fill="rgba(109,40,217,0.07)" transform="rotate(22 50 50)"/>,
  <ellipse cx="50%" cy="55%" rx="38%" ry="22%" fill="rgba(139,92,246,0.08)"/>,
  <polygon points="50,8 92,85 8,85" fill="rgba(109,40,217,0.06)"/>,
  <><circle cx="30%" cy="40%" r="18%" fill="rgba(139,92,246,0.07)"/><circle cx="72%" cy="62%" r="12%" fill="rgba(109,40,217,0.05)"/></>,
];

const MODELS = [
  {
    id: 'seedance-2',
    name: 'Seedance 2.0',
    desc: "ByteDance's flagship video model with cinematic motion control and photorealistic 4K output.",
    tags: [{ label: 'Video', cls: 'hptag-v' }, { label: '4K' }, { label: 'New' }],
    badge: 'New',
    grad: ['#080418','#150830','#080418'],
    glow: 'rgba(109,40,217,0.35)',
    videoUrl: 'https://cdn.aifield.art/cxX7tQlB2IJavePaZiwNs_video.mp4',
  },
  {
    id: 'gpt-image-2',
    name: 'GPT Image 2',
    desc: 'Next-generation image synthesis with unmatched prompt adherence and text rendering.',
    tags: [{ label: 'Image', cls: 'hptag-i' }, { label: 'HD' }, { label: 'Smart' }],
    badge: 'Hot',
    grad: ['#041410','#083a2a','#041410'],
    glow: 'rgba(16,185,129,0.3)',
    videoUrl: 'https://cdn.aifield.art/templates/b95bfd1f-358c-4e01-95de-072504629220.mp4',
  },
  {
    id: 'wan-2.7',
    name: 'Wan 2.7',
    desc: 'Advanced text-to-video generation with exceptional motion consistency and realism.',
    tags: [{ label: 'Video', cls: 'hptag-v' }, { label: 'HD' }, { label: 'New' }],
    badge: 'New',
    grad: ['#040a14','#0a1a3a','#040a14'],
    glow: 'rgba(59,130,246,0.3)',
  },
  {
    id: 'grok-imagine',
    name: 'Grok Imagine',
    desc: 'Uncensored, hyper-creative visual generation with distinct artistic styles.',
    tags: [{ label: 'Image', cls: 'hptag-i' }, { label: 'Fast' }],
    badge: null,
    grad: ['#141414','#3a3a3a','#141414'],
    glow: 'rgba(255,255,255,0.2)',
  },
  {
    id: 'nano-banana-pro',
    name: 'Nano Banana Pro',
    desc: 'Ultra-fast, stylized image generation optimized for vibrant colors and anime styles.',
    tags: [{ label: 'Image', cls: 'hptag-i' }, { label: 'Anime' }],
    badge: null,
    grad: ['#141404','#3a3a0a','#141404'],
    glow: 'rgba(234,179,8,0.3)',
  },
  {
    id: 'kling-3',
    name: 'Kling 3.0',
    desc: 'The latest iteration in cinematic video generation, offering unparalleled physics simulation.',
    tags: [{ label: 'Video', cls: 'hptag-v' }, { label: 'Pro' }, { label: 'New' }],
    badge: 'Beta',
    grad: ['#140404','#3a0a0a','#140404'],
    glow: 'rgba(239,68,68,0.3)',
  },
  {
    id: 'kling-2.6',
    name: 'Kling 2.6',
    desc: 'Highly reliable video generation perfect for consistent character and environment modeling.',
    tags: [{ label: 'Video', cls: 'hptag-v' }, { label: 'Stable' }],
    badge: null,
    grad: ['#100414','#2a0a3a','#100414'],
    glow: 'rgba(217,70,239,0.3)',
  },
  {
    id: 'flux-2-pro',
    name: 'Flux 2',
    desc: 'State-of-the-art open image synthesis with photorealistic lighting and ultra-fine detail rendering.',
    tags: [{ label: 'Image', cls: 'hptag-i' }, { label: '8MP' }, { label: 'Fast' }],
    badge: null,
    grad: ['#040814','#081428','#040814'],
    glow: 'rgba(59,130,246,0.28)',
  },
  {
    id: 'kling-2.1',
    name: 'Kling 2.1',
    desc: 'Fast, lightweight video generation model optimized for short clips and rapid ideation.',
    tags: [{ label: 'Video', cls: 'hptag-v' }, { label: 'Fast' }],
    badge: null,
    grad: ['#140a04','#3a1a0a','#140a04'],
    glow: 'rgba(249,115,22,0.3)',
  },
];

/* â”€â”€â”€ Inline styles â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */
const CSS = `
  @keyframes hpFadeUp  { from{opacity:0;transform:translateY(24px)} to{opacity:1;transform:translateY(0)} }
  @keyframes hpFloatA  { 0%,100%{transform:translateY(0)} 50%{transform:translateY(-10px)} }
  @keyframes hpFloatB  { 0%,100%{transform:translateY(0)} 50%{transform:translateY(-8px)} }
  @keyframes hpPulse   { 0%,100%{opacity:1;transform:scale(1)} 50%{opacity:.45;transform:scale(.65)} }
  @keyframes hpBlink   { 0%,100%{opacity:1} 50%{opacity:.2} }
  @keyframes hpFadeIn  { from{opacity:0} to{opacity:1} }
  @keyframes hpMoin    { from{opacity:0;transform:scale(.94) translateY(12px)} to{opacity:1;transform:scale(1) translateY(0)} }

  .hp-scroll { overflow-y:auto; overflow-x:hidden; height:100vh; scrollbar-width:thin; scrollbar-color:var(--b3) transparent; }

  .hp-nav-link { color:var(--t2); text-decoration:none; font-size:14px; font-weight:500; transition:color .2s; }
  .hp-nav-link:hover { color:var(--t1); text-decoration:none; }
  .hp-nav-actions { display:flex; align-items:center; gap:10px; }
  .hp-nav-text {
    color:var(--t2); text-decoration:none; font-size:13px; font-weight:650;
    padding:8px 10px; border-radius:8px; transition:background .2s, color .2s;
  }
  .hp-nav-text:hover { color:var(--t1); background:rgba(255,255,255,.045); text-decoration:none; }

  .hp-btn-login {
    font-size:13px; font-weight:600; color:var(--t2); background:transparent;
    border:1px solid var(--b3); padding:7px 20px; border-radius:99px;
    cursor:pointer; transition:all .2s;
  }
  .hp-btn-login:hover { background:var(--s2); color:var(--t1); border-color:rgba(255,255,255,.2); }

  .hp-btn-signup {
    font-size:13px; font-weight:700; color:#fff;
    background:linear-gradient(135deg,var(--ac),#7c3aed);
    border:none; padding:7px 20px; border-radius:99px;
    cursor:pointer; transition:all .2s; box-shadow:0 2px 12px rgba(109,40,217,.35);
  }
  .hp-btn-signup:hover { transform:translateY(-1px); box-shadow:0 6px 24px rgba(109,40,217,.5); }
  .hp-privacy-note {
    display:flex; align-items:flex-start; justify-content:space-between; gap:24px;
    border-top:1px solid var(--b1); border-bottom:1px solid var(--b1);
    padding:24px 0; margin-top:16px;
  }
  .hp-privacy-note h2 { font-size:18px; font-weight:800; color:var(--t1); margin:0 0 8px; }
  .hp-privacy-note p { font-size:13px; color:var(--t2); line-height:1.65; margin:0; max-width:760px; }

  .hp-cta-img {
    all:unset; display:inline-flex; align-items:center; gap:10px;
    padding:15px 42px; border-radius:99px; font-size:15px; font-weight:800;
    cursor:pointer; color:#fff; background:linear-gradient(135deg,var(--ac),#7c3aed);
    box-shadow:0 8px 32px rgba(109,40,217,.45);
    transition:box-shadow .3s, transform .3s;
    animation:hpFloatA 4s ease-in-out infinite;
  }
  .hp-cta-img:hover { box-shadow:0 16px 52px rgba(109,40,217,.65); transform:scale(1.06) translateY(-4px) !important; animation-play-state:paused; }

  .hp-cta-vid {
    all:unset; display:inline-flex; align-items:center; gap:10px;
    padding:15px 42px; border-radius:99px; font-size:15px; font-weight:800;
    cursor:pointer; color:#fff; background:linear-gradient(135deg,#0ea5e9,#0284c7);
    box-shadow:0 8px 32px rgba(14,165,233,.38);
    transition:box-shadow .3s, transform .3s;
    animation:hpFloatB 4.6s ease-in-out infinite;
  }
  .hp-cta-vid:hover { box-shadow:0 16px 52px rgba(14,165,233,.55); transform:scale(1.06) translateY(-4px) !important; animation-play-state:paused; }

  .hp-mcard { background:var(--s1); min-width: 240px; max-width: 240px; flex-shrink: 0; border:1px solid var(--b1); border-radius:14px; overflow:hidden; cursor:pointer; transition:border-color .3s, transform .3s, box-shadow .3s; }
  .hp-mcard:hover { border-color:rgba(139,92,246,.35); transform:translateY(-4px); box-shadow:0 20px 60px rgba(0,0,0,.7), 0 0 0 1px rgba(139,92,246,.15); }
  .hp-mcard:hover .hp-play { transform:scale(1.12); background:rgba(109,40,217,.3); }
  .hp-play { width:52px; height:52px; border-radius:50%; background:rgba(109,40,217,.18); border:1px solid rgba(139,92,246,.35); display:flex; align-items:center; justify-content:center; transition:all .25s; backdrop-filter:blur(8px); position:relative; z-index:2; }

  .hp-gi { break-inside:avoid; margin-bottom:10px; border-radius:14px; overflow:hidden; position:relative; cursor:pointer; }
  .hp-gimg { width:100%; display:block; transition:transform .5s cubic-bezier(.25,.46,.45,.94); }
  .hp-gi:hover .hp-gimg { transform:scale(1.06); }
  .hp-gov { position:absolute; inset:0; background:linear-gradient(to top,rgba(0,0,0,.75) 0%,transparent 55%); opacity:0; transition:opacity .25s; display:flex; align-items:flex-end; padding:14px; }
  .hp-gi:hover .hp-gov { opacity:1; }
  .hp-use { all:unset; display:inline-flex; align-items:center; gap:6px; background:rgba(109,40,217,.88); color:#fff; border-radius:99px; padding:7px 18px; font-size:13px; font-weight:700; cursor:pointer; transform:translateY(10px); opacity:0; transition:transform .28s cubic-bezier(.34,1.56,.64,1), opacity .2s; backdrop-filter:blur(8px); }
  .hp-gi:hover .hp-use { transform:translateY(0); opacity:1; transition-delay:.04s; }
  .hp-use:hover { background:var(--ac); }
  .hp-vpill { position:absolute; top:10px; left:10px; background:rgba(0,0,0,.55); border:1px solid rgba(255,255,255,.12); border-radius:99px; padding:4px 10px; font-size:11px; color:rgba(255,255,255,.65); display:flex; align-items:center; gap:5px; backdrop-filter:blur(8px); z-index:2; pointer-events:none; }
  .hp-vdot { width:6px; height:6px; border-radius:50%; background:#ef4444; animation:hpBlink 1.6s ease-in-out infinite; }

  .hptag { display:inline-flex; font-size:11px; padding:3px 10px; border-radius:99px; border:1px solid var(--b3); color:var(--t2); }
  .hptag-v { border-color:rgba(139,92,246,.35); color:var(--ac3); background:rgba(109,40,217,.08); }
  .hptag-i { border-color:rgba(16,185,129,.3); color:rgba(52,211,153,.85); background:rgba(16,185,129,.07); }

  .hp-seeall { font-size:13px; color:var(--ac3); text-decoration:none; font-weight:600; transition:letter-spacing .2s, color .2s; display:inline-flex; align-items:center; gap:4px; }
  .hp-seeall:hover { letter-spacing:.04em; color:var(--ac2); text-decoration:none; }

  .hp-ov { position:fixed; inset:0; z-index:500; background:rgba(0,0,10,.72); backdrop-filter:blur(14px); display:flex; align-items:center; justify-content:center; animation:hpFadeIn .2s ease; }
  .hp-modal { position:relative; background:var(--s1); border:1px solid var(--b2); border-radius:24px; padding:8px; width:100%; max-width:400px; box-shadow:0 40px 120px rgba(0,0,0,.9); animation:hpMoin .25s ease-out; margin:20px; }
  .hp-mclose { position:absolute; top:12px; right:12px; z-index:10; background:var(--s2); border:1px solid var(--b2); color:var(--t2); width:32px; height:32px; border-radius:50%; cursor:pointer; display:flex; align-items:center; justify-content:center; transition:color .2s, background .2s; font-size:14px; }
  .hp-mclose:hover { background:var(--s3); color:var(--t1); }

  /* â”€â”€ Template Lightbox â”€â”€ */
  .hp-lb-ov { position:fixed; inset:0; z-index:600; background:rgba(0,0,10,.88); backdrop-filter:blur(18px); display:flex; align-items:center; justify-content:center; animation:hpFadeIn .18s ease; }
  .hp-lb-card { position:relative; background:var(--s1); border:1px solid var(--b2); border-radius:20px; overflow:hidden; max-width:520px; width:calc(100% - 40px); box-shadow:0 40px 120px rgba(0,0,0,.95); animation:hpMoin .22s ease-out; }
  .hp-lb-close { position:absolute; top:12px; right:12px; z-index:10; background:rgba(0,0,0,.55); border:1px solid rgba(255,255,255,.12); color:#fff; width:32px; height:32px; border-radius:50%; cursor:pointer; display:flex; align-items:center; justify-content:center; transition:background .2s; font-size:14px; backdrop-filter:blur(8px); }
  .hp-lb-close:hover { background:rgba(239,68,68,.7); }
  .hp-lb-media { width:100%; display:block; max-height:62vh; object-fit:contain; background:#000; }
  .hp-lb-body { padding:16px 18px 20px; }
  .hp-lb-label { font-size:11px; font-weight:700; color:var(--t3); text-transform:uppercase; letter-spacing:.08em; margin-bottom:6px; }
  .hp-lb-prompt { font-size:13px; color:var(--t2); line-height:1.65; margin-bottom:14px; max-height:90px; overflow-y:auto; scrollbar-width:thin; }
  .hp-lb-actions { display:flex; gap:10px; align-items:center; }
  .hp-lb-copy { all:unset; display:inline-flex; align-items:center; gap:6px; background:var(--s2); border:1px solid var(--b3); color:var(--t2); border-radius:99px; padding:7px 16px; font-size:12px; font-weight:600; cursor:pointer; transition:all .2s; }
  .hp-lb-copy:hover { border-color:rgba(139,92,246,.5); color:var(--ac3); }
  .hp-lb-use { all:unset; display:inline-flex; align-items:center; gap:6px; background:var(--ac); color:#fff; border-radius:99px; padding:7px 18px; font-size:13px; font-weight:700; cursor:pointer; transition:all .2s; margin-left:auto; }
  .hp-lb-use:hover { opacity:.88; transform:translateY(-1px); }

  .hp-mgrid { scrollbar-width: none; scroll-behavior: smooth; }
  .hp-mgrid::-webkit-scrollbar { display: none; }

  .hp-scroll-btn {
    position: absolute; top: 50%; transform: translateY(-50%);
    width: 36px; height: 36px; border-radius: 50%;
    background: rgba(14,15,20,0.9); color: #fff;
    border: 1px solid rgba(139,92,246,0.6);
    display: flex; align-items: center; justify-content: center;
    cursor: pointer; z-index: 10; backdrop-filter: blur(8px);
    transition: all .2s; font-size: 20px; line-height:1;
    box-shadow: 0 4px 16px rgba(0,0,0,.5);
  }
  .hp-scroll-btn:hover { background: var(--ac); transform: translateY(-50%) scale(1.1); box-shadow: 0 4px 16px rgba(109,40,217,0.5); }
  .hp-scroll-btn.left { left: 16px; }
  .hp-scroll-btn.right { right: 16px; }
  .hp-scroll-btn.hidden { opacity: 0; pointer-events: none; }

  @media (max-width: 768px) {
    .hp-navlinks { display:none !important; }
    .hp-nav-actions { gap:6px; }
    .hp-nav-text { display:none; }
    .hp-btn-login, .hp-btn-signup { padding:7px 12px; font-size:12px; }
    .hp-privacy-note { flex-direction:column; padding:22px 0; }
    .hp-cta-img, .hp-cta-vid { padding:13px 28px; font-size:14px; }
    .hp-mgrid { grid-template-columns:1fr !important; }
    .hp-mason { columns:2 !important; }
    .hp-hero h1 { font-size:clamp(48px,13vw,90px) !important; }
    .hp-ctarow { flex-direction:column; align-items:center !important; }
    nav.hp-nav { padding:0 20px !important; }
  }
`;

/* â”€â”€â”€ Sub-components â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */
function GalleryItem({ item, idx, onUse, onOpen }) {
  const isVideo = item.vid || item.type === 'video' || item.editType === 'text_to_video' || item.editType === 'frame-to-video';
  const mediaSrc = item.mediaUrl || item.refImageUrl || item.startImageUrl || null;
  const videoRef = useRef(null);

  const handleMouseEnter = () => { if (videoRef.current) videoRef.current.play(); };
  const handleMouseLeave = () => { if (videoRef.current) { videoRef.current.pause(); videoRef.current.currentTime = 0; } };

  return (
    <div className="hp-gi" onClick={() => onOpen && onOpen(item)} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
      {/* Media â€” natural aspect ratio */}
      {mediaSrc ? (
        isVideo && item.mediaUrl ? (
          <video
            ref={videoRef}
            src={mediaSrc}
            muted
            loop
            playsInline
            preload="metadata"
            className="hp-gimg"
            style={{ objectFit:'cover', width:'100%' }}
          />
        ) : (
          <img src={mediaSrc} alt="" className="hp-gimg" style={{ objectFit:'cover', width:'100%', display:'block' }} />
        )
      ) : (
        /* Fallback: placeholder with forced AR */
        <div style={{ aspectRatio: item.ar || '1/1', background:`linear-gradient(135deg,${item.g[0]} 0%,${item.g[1]} 100%)`, position:'relative', display:'flex', alignItems:'center', justifyContent:'center' }}>
          <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" style={{ position:'absolute', inset:0 }}>
            {SVG_SHAPES[idx % SVG_SHAPES.length]}
          </svg>
        </div>
      )}
      {isVideo && <div className="hp-vpill"><span className="hp-vdot"/>Video</div>}
      <div className="hp-gov">
        <button className="hp-use" onClick={(e) => { e.stopPropagation(); onUse && onUse(item); }}>
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="13 17 18 12 13 7"/><polyline points="6 17 11 12 6 7"/>
          </svg>
          Use
        </button>
      </div>
    </div>
  );
}

function ModelCard({ m, onClick }) {
  return (
    <div className="hp-mcard" onClick={() => onClick && onClick(m)}>
      <div style={{ aspectRatio:'16/9', background:`linear-gradient(135deg,${m.grad[0]} 0%,${m.grad[1]} 50%,${m.grad[2]} 100%)`, position:'relative', display:'flex', alignItems:'center', justifyContent:'center', overflow:'hidden' }}>
        {m.videoUrl ? (
          <video src={m.videoUrl} autoPlay loop muted playsInline style={{ position:'absolute', inset:0, width:'100%', height:'100%', objectFit:'cover' }} />
        ) : (
          <div style={{ position:'absolute', inset:0, background:`radial-gradient(ellipse 70% 60% at 50% 50%,${m.glow} 0%,transparent 70%)`, pointerEvents:'none' }}/>
        )}
        {m.badge && (
          <span style={{ position:'absolute', top:12, left:12, background:'var(--ac)', color:'#fff', fontSize:10, fontWeight:800, letterSpacing:'.1em', textTransform:'uppercase', padding:'3px 10px', borderRadius:99, zIndex:2 }}>
            {m.badge}
          </span>
        )}
        {!m.videoUrl && (
          <div className="hp-play" style={{ width: 40, height: 40 }}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="white" style={{ marginLeft:2 }}><polygon points="5 3 19 12 5 21 5 3"/></svg>
          </div>
        )}
      </div>
      <div style={{ padding:'12px 14px 14px' }}>
        <div style={{ fontWeight:800, fontSize:13, color:'var(--t1)', marginBottom:4 }}>{m.name}</div>
        <div style={{ fontSize:11, color:'var(--t2)', lineHeight:1.45, marginBottom:10 }}>{m.desc}</div>
        <div style={{ display:'flex', gap:4, flexWrap:'wrap' }}>
          {m.tags.map(t => <span key={t.label} className={`hptag ${t.cls||''}`} style={{ fontSize: 9, padding: '2px 8px' }}>{t.label}</span>)}
        </div>
      </div>
    </div>
  );
}

/* â”€â”€â”€ Main â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */
export default function AifieldHome() {
  const navigate = useNavigate();
  const { user }  = useAuth();
  const [showAuth, setShowAuth] = useState(false);
  const [showHelpMenu, setShowHelpMenu] = useState(false);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(true);
  const [templates, setTemplates] = useState([]);
  const [lightboxItem, setLightboxItem] = useState(null);
  const [copied, setCopied] = useState(false);
  const gridRef = useRef(null);

  useEffect(() => {
    let cancelled = false;
    api.fetchTemplates().then(data => {
      if (cancelled) return;
      if (data && data.length > 0) {
        const shuffled = [...data].sort(() => 0.5 - Math.random());
        const top = shuffled.slice(0, 24);
        const ARS = ['3/4', '1/1', '9/16', '16/9', '4/5', '2/3', '3/2'];
        const GRADS = [['#0a0520','#1d0850'], ['#050a20','#0a1860'], ['#0c0420','#200860'], ['#08041a','#180870']];
        const mapped = top.map(t => ({
          ...t,
          ar: ARS[Math.floor(Math.random() * ARS.length)],
          g: GRADS[Math.floor(Math.random() * GRADS.length)]
        }));
        setTemplates(mapped);
      }
    }).catch(e => console.error(e));
    return () => { cancelled = true; };
  }, []);

  const goAuth = () => setShowAuth(true);
  const handleSuccess = () => { setShowAuth(false); navigate('/generate'); };
  const handleImage = () => { navigate('/generate'); };
  const handleVideo = () => { navigate('/video'); };

  const handleModelClick = (m) => {
    if (!m) return;
    const isImage = m.tags.some(t => t.label === 'Image');
    if (isImage) {
      navigate('/generate', { state: { modelId: m.id } });
    } else {
      navigate('/video', { state: { modelId: m.id } });
    }
  };

  const handleUseTemplate = useCallback((tmpl) => {
    // If fallback mock template
    if (tmpl.vid !== undefined && !tmpl.id && !tmpl.$id) {
      navigate(tmpl.vid ? '/video' : '/generate');
      return;
    }

    if (!user) { setShowAuth(true); return; }
    try {
      const isVideo = tmpl.type === 'video' || tmpl.editType === 'text_to_video' || tmpl.editType === 'frame-to-video';

      // refImageUrl can be an array or a single string depending on how it was saved
      const refImageUrls = Array.isArray(tmpl.refImageUrl)
        ? tmpl.refImageUrl
        : tmpl.refImageUrl ? [tmpl.refImageUrl] : [];

      if (!isVideo) {
        const state = { action: 'template-use', prompt: tmpl.prompt || '', modelId: tmpl.model || undefined };
        if (refImageUrls.length > 0) {
          state.sourceUrl = refImageUrls[0];
          state.refImageUrls = refImageUrls;  // pass full array
          state.action = 'use-as-reference';
        }
        navigate('/generate', { state });
      } else {
        const state = { action: 'template-use', prompt: tmpl.prompt || '', modelId: tmpl.model || undefined };
        if (tmpl.startImageUrl) {
          // Has a specific start frame — use image-to-video
          state.sourceUrl = tmpl.startImageUrl;
          state.action = 'image-to-video';
        } else if (refImageUrls.length > 0 || tmpl.refVideoUrl || tmpl.refAudioUrl) {
          // Reference-based video generation
          state.sourceUrl = refImageUrls.length > 0 ? refImageUrls[0] : null;
          state.refImageUrls = refImageUrls;
          state.action = 'use-as-reference';
        }
        state.isMultiShot = tmpl.isMultiShot || false;
        state.refVideoUrl = tmpl.refVideoUrl || null;
        state.refAudioUrl = tmpl.refAudioUrl || null;
        state.endImageUrl = tmpl.endImageUrl || null;
        state.motionControl = tmpl.motionControl || false;
        state.lipsync = tmpl.lipsync || false;

        navigate('/video', { state });
      }
    } catch (e) {
      console.error(e);
    }
  }, [user, navigate]);

  const handleScroll = useCallback(() => {
    const el = gridRef.current;
    if (!el) return;
    setCanScrollLeft(el.scrollLeft > 10);
    setCanScrollRight(el.scrollLeft < el.scrollWidth - el.clientWidth - 10);
  }, []);

  const scrollGrid = (dir) => {
    const el = gridRef.current;
    if (el) el.scrollBy({ left: dir === 'left' ? -320 : 320, behavior: 'smooth' });
  };

  return (
    <>
      <style>{CSS}</style>

      {/* Auth modal */}
      {showAuth && (
        <div className="hp-ov" onClick={() => setShowAuth(false)}>
          <div className="hp-modal" onClick={e => e.stopPropagation()}>
            <button className="hp-mclose" onClick={() => setShowAuth(false)}><Icons.X sz={14} /></button>
            <AuthPage onSuccess={handleSuccess} />
          </div>
        </div>
      )}

      <div className="hp-scroll" style={{ overflowX: 'hidden' }}>

        {/* â”€â”€ NAV â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */}
        <nav className="hp-nav" style={{ position:'fixed', top:0, left:0, right:0, zIndex:100, display:'flex', alignItems:'center', justifyContent:'space-between', padding:'0 44px', height:62, background:'rgba(7,7,10,0.82)', backdropFilter:'blur(20px)', borderBottom:'1px solid var(--b1)' }}>
          <div style={{ display:'flex', alignItems:'center', gap:9, cursor:'pointer' }} onClick={() => navigate('/home')}>
            <img src="/logo.png" alt="aiField" style={{ height:28, width:'auto' }} />
          </div>

          <div className="hp-nav-actions">
            {!user && (
              <>
                <a href="/subscription" className="hp-nav-text">Pricing</a>
                <button className="hp-btn-login" onClick={goAuth}>Login</button>
                <button className="hp-btn-signup" onClick={goAuth}>Get started free</button>
              </>
            )}
            {user && <button className="hp-btn-signup" onClick={() => navigate('/generate')}>Open App</button>}

            {/* Help Menu */}
            <div style={{ position: 'relative' }}>
              <button className="hp-btn-login" style={{ padding: '0 8px', width: 34, height: 34, display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={() => setShowHelpMenu(!showHelpMenu)}>
                <Icons.Help sz={18} />
              </button>
              {showHelpMenu && (
                <>
                  <div style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', zIndex: 90 }} onClick={() => setShowHelpMenu(false)} />
                  <div style={{
                    position: 'absolute', top: '100%', right: 0, marginTop: 8,
                    background: 'var(--bg2)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 12,
                    padding: 6, minWidth: 180, zIndex: 100,
                    boxShadow: '0 8px 32px rgba(0,0,0,0.6)',
                    display: 'flex', flexDirection: 'column', gap: 2
                  }}>
                    {[
                      { path: '/whats-new', label: "What's New", Icon: Icons.Sparkle },
                      { path: '/guide', label: 'User Guide', Icon: Icons.PenBox },
                      { path: '/help', label: 'Help Center', Icon: Icons.Help },
                      { path: '/feedback', label: 'Send Feedback', Icon: Icons.Edit },
                      { path: '/privacy', label: 'Privacy & Terms', Icon: Icons.Check }
                    ].map(item => (
                      <div key={item.path} onClick={() => { navigate(item.path); setShowHelpMenu(false); }}
                        style={{
                          padding: '8px 12px', fontSize: 13, color: 'var(--t2)', borderRadius: 8,
                          cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 8, fontWeight: 600,
                          transition: 'background 0.2s', textAlign: 'left'
                        }}
                        onMouseEnter={e => e.currentTarget.style.background = 'rgba(255,255,255,0.05)'}
                        onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
                      >
                        <item.Icon sz={14} /> {item.label}
                      </div>
                    ))}
                  </div>
                </>
              )}
            </div>
          </div>
        </nav>

        {/* â”€â”€ MAIN CONTENT (full-width) â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */}
        <div style={{ padding:'80px 0 10px' }}>
          <section style={{ position:'relative', padding:'0 44px' }}>
            <button
              className={`hp-scroll-btn left${canScrollLeft ? '' : ' hidden'}`}
              onClick={() => scrollGrid('left')}>
              {'<'}
            </button>
            <div
              ref={gridRef}
              className="hp-mgrid"
              onScroll={handleScroll}
              style={{ display:'flex', overflowX:'auto', gap:12, paddingBottom:'16px' }}>
              {MODELS.map(m => <ModelCard key={m.name} m={m} onClick={handleModelClick} />)}
            </div>
            <button
              className={`hp-scroll-btn right${canScrollRight ? '' : ' hidden'}`}
              onClick={() => scrollGrid('right')}>
              {'>'}
            </button>
          </section>
        </div>

        {/* â”€â”€ HERO â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */}
        <section className="hp-hero" style={{ display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', textAlign:'center', padding:'30px 40px', position:'relative', overflow:'hidden' }}>

          {/* Background glows */}
          <div style={{ position:'absolute', inset:0, pointerEvents:'none', background:`
            radial-gradient(ellipse 55% 55% at 50% -5%,rgba(109,40,217,0.25) 0%,transparent 70%),
            radial-gradient(ellipse 35% 35% at 15% 65%,rgba(139,92,246,0.07) 0%,transparent 60%),
            radial-gradient(ellipse 40% 35% at 85% 75%,rgba(59,130,246,0.07) 0%,transparent 60%)
          `}}/>

          {/* Eyebrow */}
          <div style={{ display:'inline-flex', alignItems:'center', gap:8, background:'rgba(109,40,217,0.1)', border:'1px solid rgba(109,40,217,0.25)', borderRadius:99, padding:'5px 16px', fontSize:11, fontWeight:700, color:'var(--ac3)', letterSpacing:'.1em', textTransform:'uppercase', marginBottom:12, animation:'hpFadeUp .6s ease both' }}>
            <span style={{ width:6, height:6, borderRadius:'50%', background:'var(--ac2)', animation:'hpPulse 2s ease-in-out infinite', display:'inline-block' }}/>
            Aifield - Now live
          </div>

          <p style={{ fontSize:14, color:'var(--t2)', maxWidth:460, lineHeight:1.7, marginBottom:20, animation:'hpFadeUp .6s .16s ease both', fontWeight:400 }}>
            Turn words into stunning images and cinematic videos using the world's most advanced creative AI models.
          </p>

          {/* CTA Buttons */}
          <div className="hp-ctarow" style={{ display:'flex', alignItems:'center', gap:24, marginBottom:10, animation:'hpFadeUp .6s .24s ease both' }}>
            <div style={{ display:'flex', flexDirection:'column', alignItems:'center', gap:10 }}>
              <span style={{ fontSize:11, color:'var(--t3)', letterSpacing:'.05em' }}>Generate images</span>
              <button className="hp-cta-img" onClick={handleImage}>
                <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="3" y="3" width="18" height="18" rx="3"/>
                  <circle cx="8.5" cy="8.5" r="1.5"/>
                  <polyline points="21 15 16 10 5 21"/>
                </svg>
                Image
              </button>
            </div>

            <span style={{ fontSize:13, color:'var(--t3)' }}>or</span>

            <div style={{ display:'flex', flexDirection:'column', alignItems:'center', gap:10 }}>
              <span style={{ fontSize:11, color:'var(--t3)', letterSpacing:'.05em' }}>Create videos</span>
              <button className="hp-cta-vid" onClick={handleVideo}>
                <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <polygon points="23 7 16 12 23 17 23 7"/>
                  <rect x="1" y="5" width="15" height="14" rx="2"/>
                </svg>
                Video
              </button>
            </div>
          </div>

          <p style={{ fontSize:12, color:'var(--t3)', animation:'hpFadeUp .6s .3s ease both' }}>
            No credit card - <strong style={{ color:'var(--ac3)' }}>10 free credits</strong> on signup
          </p>
        </section>

        <div style={{ maxWidth:1360, margin:'0 auto', padding:'20px 40px 80px' }}>
          {/* Gallery */}
          <section>
            <div style={{ marginBottom:16, textAlign:'center' }}>
              <h2 style={{ fontFamily:'var(--f)', fontSize:'clamp(18px,2.5vw,24px)', fontWeight:700, color:'var(--t1)', letterSpacing:'-0.02em' }}>Templates</h2>
            </div>
            <div className="hp-mason" style={{ columns:6, columnGap:10, marginBottom:32 }}>
              {(templates.length > 0 ? templates : GALLERY).map((item, i) => (
                <GalleryItem key={item.id || item.$id || i} item={item} idx={i} onUse={handleUseTemplate} onOpen={setLightboxItem} />
              ))}
            </div>
            <div style={{ display:'flex', justifyContent:'center', marginBottom: 60 }}>
              <button onClick={() => navigate('/explore')} className="hp-btn-login" style={{ textDecoration:'none', cursor:'pointer' }}>Full gallery</button>
            </div>
          </section>

          {/* Transparency Section */}
          <section className="hp-privacy-note">
            <div>
              <h2>Data & Privacy Transparency</h2>
              <p>
              At aiField, we value your privacy and are transparent about how we use your data. We use <strong>Firebase Authentication</strong> to secure your account. 
              We only store your email address and name to manage your <strong>subscription credits</strong> and ensure you have access to your generated content across devices. 
              Your data is never sold to third parties.
              </p>
            </div>
            <a href="/privacy" className="hp-seeall" style={{ whiteSpace: 'nowrap' }}>Privacy policy</a>
          </section>
        </div>

        {/* â”€â”€ FOOTER â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */}
        <footer style={{ borderTop:'1px solid var(--b1)', padding:'28px 44px', display:'flex', alignItems:'center', justifyContent:'space-between', maxWidth:1360, margin:'0 auto', fontSize:13, color:'var(--t3)' }}>
          <span>(c) 2026 Aifield - All rights reserved.</span>
          <div style={{ display:'flex', gap:20, alignItems:'center' }}>
            <a href="/privacy" style={{ color:'var(--t3)', textDecoration:'none' }} className="hp-nav-link">Privacy Policy</a>
            <a href="/help" style={{ color:'var(--t3)', textDecoration:'none' }} className="hp-nav-link">Terms</a>
            <a href="https://aifield.art" target="_blank" rel="noopener noreferrer" style={{ color:'var(--ac3)', textDecoration:'none', fontWeight:600 }}>aifield.art</a>
          </div>
        </footer>

      </div>
      {/* â”€â”€ TEMPLATE LIGHTBOX â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */}
      {lightboxItem && (() => {
        const lb = lightboxItem;
        const isVideo = lb.vid || lb.type === 'video' || lb.editType === 'text_to_video' || lb.editType === 'frame-to-video';
        const mediaSrc = lb.mediaUrl || lb.refImageUrl || lb.startImageUrl || null;
        const prompt = lb.prompt || '';
        const handleCopy = () => {
          if (!prompt) return;
          navigator.clipboard.writeText(prompt).then(() => { setCopied(true); setTimeout(() => setCopied(false), 2000); });
        };
        return (
          <div className="hp-lb-ov" onClick={() => setLightboxItem(null)}>
            <div className="hp-lb-card" onClick={e => e.stopPropagation()}>
              <button className="hp-lb-close" onClick={() => setLightboxItem(null)}><Icons.X sz={14} /></button>
              {/* Media */}
              {mediaSrc && (
                isVideo && lb.mediaUrl ? (
                  <video src={mediaSrc} autoPlay muted loop playsInline className="hp-lb-media" />
                ) : (
                  <img src={mediaSrc} alt="" className="hp-lb-media" />
                )
              )}
              {/* Body */}
              <div className="hp-lb-body">
                {prompt ? (
                  <>
                    <div className="hp-lb-label">Prompt</div>
                    <div className="hp-lb-prompt">{prompt}</div>
                  </>
                ) : (
                  <div className="hp-lb-label" style={{ marginBottom: 14 }}>No prompt available</div>
                )}
                <div className="hp-lb-actions">
                  {prompt && (
                    <button className="hp-lb-copy" onClick={handleCopy}>
                      {copied ? (
                        <><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg> Copied!</>
                      ) : (
                        <><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg> Copy Prompt</>
                      )}
                    </button>
                  )}
                  <button className="hp-lb-use" onClick={() => { setLightboxItem(null); handleUseTemplate(lb); }}>
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="13 17 18 12 13 7"/><polyline points="6 17 11 12 6 7"/></svg>
                    Use Template
                  </button>
                </div>
              </div>
            </div>
          </div>
        );
      })()}

    </>
  );
}


